(function () {
  'use strict';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initialiseSaleBar(bar) {
    if (!bar || bar.dataset.ozSaleInitialised === 'true') return;
    bar.dataset.ozSaleInitialised = 'true';

    var endValue = (bar.getAttribute('data-sale-end') || '').trim();
    var timer = bar.querySelector('[data-oz-global-sale-timer]');

    if (!endValue) {
      bar.hidden = false;
      if (timer) timer.hidden = true;
      return;
    }

    var endTime = Date.parse(endValue);
    if (!Number.isFinite(endTime)) {
      bar.hidden = true;
      return;
    }

    var daysNode = bar.querySelector('[data-oz-sale-days]');
    var hoursNode = bar.querySelector('[data-oz-sale-hours]');
    var minutesNode = bar.querySelector('[data-oz-sale-minutes]');
    var secondsNode = bar.querySelector('[data-oz-sale-seconds]');
    var intervalId = null;

    function update() {
      var remaining = endTime - Date.now();

      if (remaining <= 0) {
        bar.hidden = true;
        if (intervalId) window.clearInterval(intervalId);
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysNode) daysNode.textContent = String(days);
      if (hoursNode) hoursNode.textContent = pad(hours);
      if (minutesNode) minutesNode.textContent = pad(minutes);
      if (secondsNode) secondsNode.textContent = pad(seconds);

      if (timer) {
        timer.hidden = false;
        timer.setAttribute(
          'aria-label',
          days + ' days, ' + hours + ' hours, ' + minutes + ' minutes and ' + seconds + ' seconds remaining'
        );
      }

      bar.hidden = false;
    }

    update();
    if (!bar.hidden) intervalId = window.setInterval(update, 1000);
  }

  function initialiseAll() {
    document.querySelectorAll('[data-oz-global-sale]').forEach(initialiseSaleBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
